var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "files-pane" },
    [
      _vm.isLoading
        ? _c("div", { staticClass: "files-pane__state" }, [_c("b-spinner")], 1)
        : !_vm.items.length && _vm.isFiltered
        ? _c("div", { staticClass: "files-pane__state" }, [
            _vm._v("\n    No Image Files\n  "),
          ])
        : !_vm.items.length
        ? _c(
            "button",
            {
              staticClass: "files-pane__empty",
              attrs: { type: "button", disabled: !_vm.canBrowse },
              on: {
                click: function ($event) {
                  return _vm.$emit("browse")
                },
              },
            },
            [
              _c(
                "svg",
                {
                  staticClass: "lucide lucide-upload h-8 w-8 opacity-50",
                  attrs: {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: "24",
                    height: "24",
                    viewBox: "0 0 24 24",
                    fill: "none",
                    stroke: "currentColor",
                    "stroke-width": "2",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                  },
                },
                [
                  _c("path", {
                    attrs: { d: "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" },
                  }),
                  _vm._v(" "),
                  _c("polyline", { attrs: { points: "17 8 12 3 7 8" } }),
                  _vm._v(" "),
                  _c("line", {
                    attrs: { x1: "12", x2: "12", y1: "3", y2: "15" },
                  }),
                ]
              ),
              _vm._v(" "),
              _c("span", { staticClass: "files-pane__empty-title" }, [
                _vm._v(_vm._s(_vm.emptyTitle)),
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "files-pane__empty-hint" }, [
                _vm._v(_vm._s(_vm.emptyHint)),
              ]),
            ]
          )
        : _vm._l(_vm.itemGroups, function (group) {
            return _c("ItemGrid", {
              key: group.key,
              staticClass: "files-pane__grid",
              class: group.class,
              attrs: {
                items: group.items,
                "is-selected": _vm.isSelected,
                columns: _vm.GRID_COLUMNS,
                "columns-md": _vm.GRID_COLUMNS_MD,
                "item-props": {
                  showCheckbox: true,
                  uploadOnDrop: true,
                  actions: _vm.actions,
                },
                "item-props-for": _vm.itemPropsFor,
              },
              on: {
                "item-click": _vm.onItemClick,
                "item-dblclick": _vm.onItemDoubleClick,
                "item-count-change": _vm.changeCount,
                "item-action": _vm.onItemAction,
                "item-drop": _vm.onItemDrop,
                "open-preview": (item) => _vm.$emit("open-preview", item),
              },
            })
          }),
      _vm._v(" "),
      _vm.lastPage > 1
        ? _c("ItemPagination", {
            attrs: {
              value: _vm.currentPage,
              "total-rows": _vm.totalRows,
              "per-page": _vm.pageSize,
            },
            on: { change: _vm.fetchItems },
          })
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }